import { DocumentSubType } from '@model/ftf-api.model';
import { createAction, props } from '@ngrx/store';

/**
 * Action to trigger loading of document sub types.
 */
export const loadDocumentSubTypes = createAction('[DocumentSubTypes] Load Document Sub Types');

/**
 * Action dispatched when document sub types are successfully loaded.
 */
export const loadDocumentSubTypesSuccess = createAction(
  '[DocumentSubTypes] Load Document Sub Types Success',
  props<{ subtypes: DocumentSubType[] }>()
);

/**
 * Action dispatched when loading document sub types fails.
 */
export const loadDocumentSubTypesFailure = createAction(
  '[DocumentSubTypes] Load Document Sub Types Failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>()
);
